export default __webpack_public_path__ + "d43a21e4510a25c2ae57ff5ac40d79fe.svg";